var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.80176 5.3125H0V17H3.80176V5.3125Z","fill":"white","key":0}),React.createElement("path",{"d":"M14.157 5.44946C14.1155 5.43701 14.0781 5.42456 14.0366 5.41211C13.9868 5.39966 13.9329 5.39136 13.8831 5.38306C13.6797 5.34155 13.4597 5.3125 13.2024 5.3125C10.9861 5.3125 9.5791 6.92285 9.11841 7.54541V5.3125H5.3125V17H9.11426V10.625C9.11426 10.625 11.9863 6.62402 13.1982 9.5625V17H17V9.11426C17 7.34619 15.7881 5.87695 14.157 5.44946Z","fill":"white","key":1}),React.createElement("path",{"d":"M3.71875 1.85938C3.71875 2.88452 2.88452 3.71875 1.85938 3.71875C0.834228 3.71875 0 2.88452 0 1.85938C0 0.834228 0.834228 0 1.85938 0C2.88452 0 3.71875 0.834228 3.71875 1.85938Z","fill":"white","key":2})]);
}

LinkedinInline.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
